// Shared motion architecture — framer-motion only.
// One place for every animation curve/variant. Reduced motion is handled by
// framer-motion's useReducedMotion at call sites + the global CSS media query.

export const EASE_OUT = [0.22, 1, 0.36, 1];

export const fadeUp = {
  hidden: { opacity: 0, y: 28 },
  show: { opacity: 1, y: 0, transition: { duration: 0.7, ease: EASE_OUT } },
};

export const fadeIn = {
  hidden: { opacity: 0 },
  show: { opacity: 1, transition: { duration: 0.9, ease: EASE_OUT } },
};

export const staggerParent = (stagger = 0.09, delay = 0) => ({
  hidden: {},
  show: { transition: { staggerChildren: stagger, delayChildren: delay } },
});

// whileInView props for scroll-reveal sections — fires once, slightly early.
export const revealOnce = {
  initial: "hidden",
  whileInView: "show",
  viewport: { once: true, margin: "-12% 0px -12% 0px" },
};

// Subtle page transition — opacity + micro-lift. Fast, interruptible.
export const pageMotion = {
  initial: { opacity: 0, y: 10 },
  animate: { opacity: 1, y: 0, transition: { duration: 0.4, ease: EASE_OUT } },
  exit: { opacity: 0, transition: { duration: 0.18 } },
};
